import { useState } from "react";
import { PageHeader } from "@evertrue/et-components";
import { PropTypes } from "base/react-libs";
import { Icon } from "@evertrue/et-components";
import NavigationSubItem from "apps/layout/components/navigation-sub-item";
import PauseJourneyForm from "./pause/pause-journey-form";
import CallSettings from "./calls/journeys-call-settings";

const NavigationItem = ({ label, isActive, onClick }) => (
  <NavigationSubItem
    icon=""
    label={label}
    isActive={isActive}
    onClick={onClick}
    className={isActive ? "journey-settings-active" : "journey-setings-inactive"}
  />
);

NavigationItem.propTypes = {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const JourneysSettings = ({ setShowSettings }) => {
  const [activeTab, setActiveTab] = useState("pause");

  const changeActive = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <div className="journey-settings-title">
        <Icon icon="chevron-left" size={2} className="settings-back" onClick={() => setShowSettings(false)} />
        <PageHeader title="Settings" className="journey-settings-header" />
      </div>
      <div className="journey-settings-content">
        <div className="journey-settings-left-nav">
          <PageHeader title="Cadences" className="journey-settings-sub-header" />
          <NavigationItem
            label="Pause Cadences"
            isActive={activeTab === "pause"}
            onClick={() => changeActive("pause")}
          />
          <PageHeader title="Outreach" className="journey-settings-sub-header" />
          <NavigationItem label="Calls" isActive={activeTab === "calls"} onClick={() => changeActive("calls")} />
        </div>
        <div className="journey-settings-right-nav-content">
          {activeTab === "pause" && <PauseJourneyForm setShowSettings={setShowSettings} />}
          {activeTab === "calls" && (
            <>
              <CallSettings />
            </>
          )}
        </div>
      </div>
    </>
  );
};

JourneysSettings.propTypes = {
  setShowSettings: PropTypes.func,
};

export default JourneysSettings;
